import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FileText, ArrowRight, Radar, Sparkles, Award, Download, CheckCircle2 } from "lucide-react";
import PageTour from "@/components/PageTour";

export default function Proposals() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/proposals").then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="p-8 stagger-in" data-testid="proposals-page">
      <div className="mb-8 flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="mono-label text-cyan-400 mb-2">// DRAFTS</div>
          <h1 className="font-display font-black text-4xl tracking-tight">Proposals</h1>
          <p className="text-slate-400 mt-2">{items.length} in the queue</p>
        </div>
        <PageTour
          storageKey="bf_proposals_tour_v1"
          eyebrow="PROPOSALS"
          title="Drafting a winning proposal"
          Icon={FileText}
          tone="fuchsia"
          steps={[
            { Icon: Radar,       tone: "indigo",  title: "1. Pick an opportunity",          body: "Every proposal starts from a saved opportunity. Head to Opportunities, open a solicitation, and hit BID/NO-BID first — that scores your fit and unlocks the proposal button." },
            { Icon: Sparkles,    tone: "fuchsia", title: "2. Generate the 14-section draft", body: "GENERATE PROPOSAL runs 14 parallel Claude calls — Executive Summary, Technical Approach, Past Performance, Pricing, and more — using your Company profile + Branding. Costs 3 credits." },
            { Icon: Award,       tone: "amber",   title: "3. Cite your past performance",    body: "The Proposal Agent auto-picks the best-matched projects from your Past Performance library. Add more entries there to strengthen every future draft." },
            { Icon: FileText,    tone: "violet",  title: "4. Edit each section inline",      body: "Every section is fully editable. Save-as-you-type persists to the workspace. Regenerate just one section if you want a different angle without spending 3 credits on the whole draft." },
            { Icon: Download,    tone: "emerald", title: "5. Export DOCX / PDF / Binder",    body: "Construction NAICS auto-picks the Submittals Binder (Slate Creek pattern with SOV + Approved By blocks). Everything else exports as a 14-section narrative PDF + Word doc, branded with your logo, UEI, CAGE, DUNS, and signatory." },
          ]}
        />
      </div>

      <div className="bg-[#0D1424] border border-white/10">
        {items.length === 0 && (
          <div className="p-12 text-center text-slate-500">
            <FileText className="w-10 h-10 mx-auto mb-4 text-slate-600" />
            <div>No proposals yet. Analyze an opportunity, then draft a proposal.</div>
            <Link to="/opportunities" className="mt-4 inline-flex items-center gap-2 mono-label text-cyan-400 hover:text-cyan-300">Browse opportunities <ArrowRight className="w-3.5 h-3.5" /></Link>
          </div>
        )}
        {items.map((p) => (
          <Link key={p.proposal_id} to={`/proposals/${p.notice_id}`} className="flex items-center justify-between p-5 border-b border-white/5 hover:bg-white/[0.02] transition-colors" data-testid={`proposal-${p.proposal_id}`}>
            <div className="min-w-0 flex-1">
              <div className="mono-label text-slate-500 mb-1">{p.status?.toUpperCase()}</div>
              <div className="font-medium truncate">{p.title}</div>
              <div className="text-xs text-slate-500 mt-1">{p.updated_at && new Date(p.updated_at).toLocaleString()}</div>
            </div>
            <ArrowRight className="w-5 h-5 text-slate-500" />
          </Link>
        ))}
      </div>
    </div>
  );
}
